import {StringTransformer} from './string-transformer';
import {PageComponent} from './page-component';

export class NewsItemContentPageComponent extends PageComponent<
  NewsItemContentPageComponent,
  'newsItemContent'
> {
  constructor(el: any = {}) {
    super(el, 'newsItemContent', ['NewsItem']);
  }

  public override getSearchKeys(): string[] {
    return [];
  }

  public override applyStringTransformer(
    transformer: StringTransformer,
  ): NewsItemContentPageComponent {
    const res = new NewsItemContentPageComponent(this.toJson());

    return res;
  }

  public override toJson(): any {
    const parent: any = super.toJson();
    return {
      ...parent,
    };
  }
}
